import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./FormLayoutIndicator.styles";

interface FormLayoutIndicatorProps {
	children: ReactNode;
}

const FormLayoutIndicator = ({ children }: FormLayoutIndicatorProps): ReactElement => {
	const styles = useStyles();

	return (
		<div className={styles.formIndicator}>
			<div className={styles.formIndicatorContent}>{children}</div>
		</div>
	);
};
export default FormLayoutIndicator;
